export default __webpack_public_path__ + "static/media/canvaRoundLogo.7a6f2b52.png";